import { Space, Tag, Typography } from 'antd';
import React from 'react';
import { Enums } from '../../../shared';
import ExternalResourceAvatar from '../../common/ExternalResourceAvatar';
import { useTranslation } from 'react-i18next';
import { FileOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SubmissionsList = ({ submissions, disabled }) => {
    const { t } = useTranslation();
    const submissionStatusTagColor = {
        [Enums.COURSE_STEP_EVALUATION_STATUS.WAITING]: 'warning',
        [Enums.COURSE_STEP_EVALUATION_STATUS.PASSED]: 'success',
        [Enums.COURSE_STEP_EVALUATION_STATUS.FAILED]: 'error',
        [Enums.COURSE_STEP_EVALUATION_STATUS.SUBMITTED]: 'processing',
    };

    const submissionStatusTagText = {
        [Enums.COURSE_STEP_EVALUATION_STATUS.WAITING]: t('waiting'),
        [Enums.COURSE_STEP_EVALUATION_STATUS.PASSED]: t('approved'),
        [Enums.COURSE_STEP_EVALUATION_STATUS.FAILED]: t('rejected'),
        [Enums.COURSE_STEP_EVALUATION_STATUS.SUBMITTED]: t('submitted'),
    };

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Text disabled={disabled} strong>
                {t('courses.submissions')}
            </Text>
            {submissions.map((submission) => (
                <Space style={{ width: '100%' }} key={submission.id}>
                    <ExternalResourceAvatar
                        key={submission.id}
                        url={submission.file_link}
                        title={submission.title}
                        disabled={disabled}
                        icon={<FileOutlined />}
                    />
                    <Tag color={submissionStatusTagColor[submission.status]}>
                        {submissionStatusTagText[submission.status]}
                    </Tag>
                </Space>
            ))}
        </Space>
    );
};

export default SubmissionsList;
